import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import { sendHoverSoundCommand, sendClickSoundCommand } from '../../helpers/web_to_client'

import styles from './ButtonToggleSmall.scss'

class ButtonToggleSmall extends React.PureComponent {
    static propTypes = {
        caption: PropTypes.node.isRequired,
        isChecked: PropTypes.bool.isRequired,
        onClick: PropTypes.func.isRequired,

        isDisabled: PropTypes.bool,
        tabIndex: PropTypes.number,
        tooltipId: PropTypes.string,
    }

    static defaultProps = {
        tabIndex: -1,
    }

    static conditionClassName(condition) {
        return classNames(styles.condition, styles[`condition__${condition}`])
    }

    handleDisabledClick(e) {
        e.preventDefault()
    }

    handleClick = (e) => {
        sendClickSoundCommand()
        this.props.onClick(e)
    }

    render() {
        const className = classNames(styles.base, styles.base__secondary, {
            [styles.base__disabled]: this.props.isDisabled,
        })

        const dataAttrs = this.props.tooltipId ? {
            'data-tip': true,
            'data-for': this.props.tooltipId,
        } : {}

        return (
            <label
                className={className}
                tabIndex={this.props.tabIndex}
                {...dataAttrs}
                onMouseEnter={this.props.isDisabled ? null : sendHoverSoundCommand}
                onClick={this.props.isDisabled ? this.handleDisabledClick : null}
            >
                <input
                    className={styles.input}
                    type='checkbox'
                    onChange={this.props.isDisabled ? null : this.handleClick}
                    checked={this.props.isChecked}
                />
                <span className={styles.marker} />
                <span className={ButtonToggleSmall.conditionClassName('active')} />
                <span className={ButtonToggleSmall.conditionClassName('hover')} />
                <span className={ButtonToggleSmall.conditionClassName('focus')} />
                <span className={ButtonToggleSmall.conditionClassName('disabled')} />
                <span className={styles.caption}>{this.props.caption}</span>
            </label>
        )
    }
}

export default ButtonToggleSmall



// WEBPACK FOOTER //
// ../node_modules/react-wot-bootstrap/lib/components/ButtonToggleSmall/ButtonToggleSmall.jsx